import styled from 'styled-components';

export const CreateToolPageStyle = styled.div`
  width: 100%;
  max-width: 896px;
  padding: 32px 24px 48px;
  color: var(--white);

  @media (min-width: 1024px) {
    padding: 40px 40px 56px;
  }

  .back-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 24px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #a0a0a0;
    font-size: 14px;
    cursor: pointer;

    &:hover {
      color: var(--white);
    }
  }

  .page-header {
    margin-bottom: 32px;

    h1 {
      margin: 0 0 8px;
      font-size: 30px;
      line-height: 36px;
      font-weight: 700;
      color: var(--white);
    }

    p {
      margin: 0;
      font-size: 15px;
      line-height: 22px;
      color: #a0a0a0;
    }
  }

  .loading-line {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
    font-size: 14px;
    color: #a0a0a0;

    .spin {
      animation: spin 0.8s linear infinite;
      color: var(--primary);
    }
  }

  .skeleton-stack {
    display: flex;
    flex-direction: column;
    gap: 24px;

    .skeleton {
      height: 140px;
      border-radius: 12px;
      background: #161616;
      border: 1px solid #262626;
      animation: pulse 1.4s ease-in-out infinite;
    }
  }

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.55;
    }
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  .sections {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .section {
    padding: 20px;
    border-radius: 12px;
    background: #161616;
    border: 1px solid #262626;
  }

  .section-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 16px;

    h4 {
      margin: 0;
      font-size: 14px;
      font-weight: 600;
      color: var(--white);
    }

    p {
      margin: 4px 0 0;
      font-size: 12px;
      color: #808080;
    }
  }

  .add-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 0;
    border: 0;
    background: transparent;
    color: var(--primary);
    font-size: 12px;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  .field {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .label {
    font-size: 14px;
    color: var(--white);

    .req {
      color: #ef4444;
    }
  }

  .input,
  .select,
  .textarea {
    width: 100%;
    padding: 8px 12px;
    border-radius: 8px;
    border: 1px solid #262626;
    background: #0e0e0e;
    color: var(--white);
    font-size: 14px;
    outline: none;

    &::placeholder {
      color: #606060;
    }

    &:focus {
      border-color: rgba(3, 160, 141, 0.4);
    }
  }

  .textarea {
    resize: none;
  }

  .select {
    appearance: none;
  }

  .grid-2 {
    display: grid;
    gap: 16px;

    @media (min-width: 768px) {
      grid-template-columns: 1fr 1fr;
    }
  }

  .grid-4 {
    display: grid;
    gap: 16px;

    @media (min-width: 768px) {
      grid-template-columns: 3fr 1fr;
    }
  }

  .stack {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .empty-note {
    margin: 0;
    font-size: 12px;
    color: #606060;
  }

  .def-card {
    padding: 16px;
    border-radius: 8px;
    border: 1px solid #262626;
    background: rgba(14, 14, 14, 0.6);
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .def-head {
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
      font-size: 12px;
      font-weight: 500;
      color: #a0a0a0;
    }
  }

  .icon-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: #606060;
    cursor: pointer;

    &:hover {
      color: #ef4444;
    }
  }

  .header-row {
    display: flex;
    align-items: center;
    gap: 8px;

    .input {
      flex: 1;
    }
  }

  .editor-wrap {
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #262626;
  }

  .output {
    margin: 0;
    padding: 12px;
    min-height: 64px;
    max-height: 256px;
    overflow-y: auto;
    border-radius: 8px;
    border: 1px solid #262626;
    background: #0e0e0e;
    color: #c8c8c8;
    font-size: 12px;
    white-space: pre-wrap;
  }

  .meta-grid {
    display: grid;
    gap: 12px;

    @media (min-width: 768px) {
      grid-template-columns: 2fr 1fr;
    }
  }

  .meta-box {
    padding: 12px;
    border-radius: 8px;
    border: 1px solid #262626;
    background: #0e0e0e;

    .k {
      margin: 0 0 4px;
      font-size: 12px;
      font-weight: 500;
      color: #a0a0a0;
    }

    .v {
      margin: 0;
      font-size: 14px;
      color: var(--white);
      word-break: break-all;
    }
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 32px;

    button {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 10px 24px;
      border-radius: 999px;
      font-size: 14px;
      cursor: pointer;
    }

    .cancel {
      border: 1px solid #262626;
      background: transparent;
      color: #a0a0a0;

      &:hover {
        color: var(--white);
      }
    }

    .primary {
      border: 0;
      background: var(--primary);
      color: var(--white);
      font-weight: 500;

      &:hover:not(:disabled) {
        opacity: 0.9;
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }

  .section-actions {
    display: flex;
    justify-content: flex-end;

    .primary {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 8px 20px;
      border: 0;
      border-radius: 999px;
      background: var(--primary);
      color: var(--white);
      font-size: 13px;
      font-weight: 500;
      cursor: pointer;

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
`;

/** Legacy exports kept so old imports do not break */
export const ToolOverlay = styled.div``;
export const StyledCreateToolModal = CreateToolPageStyle;
